import Vue from 'vue'
import Router from 'vue-router'
import store from './store/'
import Home from './views/Home.vue'

Vue.use(Router)

const router = new Router({
	mode: 'hash',
	routes: [
	{
		path: '/',
		name: 'home',
		component: Home,
		meta: {requiresAuth: true},
	},
	{
		path: '/auth',
		component: () => import('./views/Auth/Auth.vue'),
		children: [
		{
			path: '',
			redirect: {name: 'login'},
		},
		{
			path: '/auth/login',
			name: 'login',
			component: () => import('./views/Auth/Login.vue'),
		},
		]
	},
	{
		path: '/settings',
		name: 'settings',
		component: () => import('./views/Settings.vue'),
		meta: {requiresAuth: true}
	},
	{
		path: '/users',
		name: 'users',
		component: () => import('./views/Users/Users.vue'),
		meta: {requiresAuth: true}
	},
	{
		path: '/users/create',
		name: 'create-user',
		component: () => import('./views/Users/Create.vue'),
		meta: {requiresAuth: true}
	},
	{
		path: '/users/:id',
		name: 'user',
		component: () => import('./views/Users/User.vue'),
		meta: {requiresAuth: true}
	},
	{
		path: '/customers',
		name: 'customers',
		component: () => import('./views/Customers/Customers.vue'),
		meta: {requiresAuth: true}
	},
	{
		path: '/customers/create',
		name: 'create-customer',
		component: () => import('./views/Customers/Create.vue'),
		meta: {requiresAuth: true}
	},
	{
		path: '/customers/:id',
		name: 'customer',
		component: () => import('./views/Customers/Customer.vue'),
		meta: {requiresAuth: true}
	},
	{
		path: '/machines',
		name: 'machines',
		component: () => import('./views/Machines/Machines.vue'),
		meta: {requiresAuth: true}
	},
	{
		path: '/machines/create',
		name: 'create-machine',
		component: () => import('./views/Machines/Create.vue'),
		meta: {requiresAuth: true}
	},
	{
		path: '/machines/:id',
		name: 'machine',
		component: () => import('./views/Machines/Machine.vue'),
		meta: {requiresAuth: true}
	},
	{
		path: '/machine-types',
		name: 'machine-types',
		component: () => import('./views/MachineTypes/MachineTypes.vue'),
		meta: {requiresAuth: true}
	},
	{
		path: '/machine-types/create',
		name: 'create-machine-type',
		component: () => import('./views/MachineTypes/Create.vue'),
		meta: {requiresAuth: true}
	},
	{
		path: '/machine-types/:id',
		name: 'machine-type',
		component: () => import('./views/MachineTypes/MachineType.vue'),
		meta: {requiresAuth: true}
	},
	{
		path: '/documents',
		name: 'documents',
		component: () => import('./views/Documents/Documents.vue'),
		meta: {requiresAuth: true}
	},
	{
		path: '/documents/create',
		name: 'create-document',
		component: () => import('./views/Documents/Create.vue'),
		meta: {requiresAuth: true}
	},
	{
		path: '/documents/:id',
		name: 'document',
		component: () => import('./views/Documents/Document.vue'),
		meta: {requiresAuth: true}
	},
	]
});

// beforeResolve perchè a differenza di beforeEach mi permette di chiamare anche i guard nei child
router.beforeResolve(async (to, from, next) => {
	if (to.matched.some(record => record.meta.requiresAuth)) {
		// this route requires auth, check if logged in
		// if not, redirect to login page.
		if (store.getters.isConnectionError) {
			try {
				let token = await Vue.storage.getItem('user-token');
				await Vue.utils.autoLogin(token);
				if (store.getters.isConnectionError) {
					store.dispatch('setConnectionError', {connectionError: false});
				}
			} catch(e) {
				// next(false);
				next({
					name: 'login'
				});
				return;
			}

		}
		if (!store.getters.isAuthenticated) {
			next({
				name: 'login',
				query: {redirect: to.fullPath}
			});
			return;
		}
	}

	next(); // make sure to always call next()!
	return;
});

export default router;